import { createSlice } from '@reduxjs/toolkit';
import { Occupations, IOccupations } from './occupations';
import { Nationalities, INationalities } from './nationalities';
import { ContactInformation, IContactInfo } from './contact-information';
import { PremiumTerms, IPremiumTerm } from './premium-term';
import { Salutations, ISalutation } from './salutation';
import { Business, IBusiness } from './businesses';
import { Banks, IBank } from './banks';
import { PaymentFrequency, IFrequency } from './payment-frequency';
export interface StaticState {
  occupations: IOccupations[];
  nationlaities: INationalities[];
  contactInformation: IContactInfo[];
  premiumTerms: IPremiumTerm[];
  salutations: ISalutation[];
  businesses: IBusiness[];
  banks: IBank[];
  paymentFrequency: IFrequency[];
}

const initialState: StaticState = {
  occupations: Occupations,
  nationlaities: Nationalities,
  contactInformation: ContactInformation,
  premiumTerms: PremiumTerms,
  salutations: Salutations,
  businesses: Business,
  banks: Banks,
  paymentFrequency: PaymentFrequency
}

const staticSlice = createSlice({
  name: 'static',
  initialState,
  reducers: {
  },
  extraReducers: {}
});

export default staticSlice.reducer;